import { useEffect, type ReactNode } from 'react';

type Props = {
  open: boolean;
  title: string;
  body?: ReactNode;
  actions: ReactNode;
  onClose: () => void;
};

export function Modal({ open, title, body, actions, onClose }: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="modal-backdrop"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <h3 className="modal-title">{title}</h3>
        {body && <div>{body}</div>}
        <div className="modal-actions">{actions}</div>
      </div>
    </div>
  );
}
